<template>
    <header class="header" :class="{develop: VUE_APP_DEVELOP == 'develop'}">
        <div class="container-fluid">
            <div class="col-logo">
                <a :href="`/${flagSelected}/`" class="logo">
                    <img src="@/assets/images/header/logo-dne-merchant.svg" alt="DNE Market" class="anime">
                </a>
            </div>

            <div class="col-header"
            :class='{search: dataSource == "search",
                menus: dataSource == "menus",
                categories: dataSource.type_code == "categories",
                headerAccount: dataSource == "account",
                headerMerchant: dataSource == "merchant"}'>

                <Menu :dataSource="dataSource" v-if="dataSource != 'search'" />
            </div>
            
            <div class="col-tools">
                <Login :dataSource="dataSourceHeader.isMerchant" />
                
                <div><div class="openSidebar" @click="openSidebar('menu')"></div></div>

                <div class="openSettings" @click="openSidebar('settings')">
                    <div class="flag">
                        <div class="load-flag" v-if="!settings.flagShow"></div>
                        <img v-if="settings.flagShow" :src="`https://imagedelivery.net/-5Lr2B91XIIGgp5YOFIoTg/${settings.flagLanguage}/flags`">
                    </div>
                    
                    <small v-if="settings.languageName">
                        {{settings.languageName.slice(0, 3)}}<br>{{settings.currencyShort}}
                    </small>
                </div>
            </div>
        </div>
    </header>


    <!-- SIDEBAR MENU -->
    <div class="sidebar" id="SidebarMarket" v-if="sidebar.menu">
        <div class="closeSidebar" @click="closeSidebar()"></div>
        <Sidebar :dataSource="dataSourceHeader" />
    </div>


    <!-- SIDEBAR SETTINGS -->
    <div class="sidebar" :class="{hide: sidebar.login}" v-if="sidebar.settings">
        <div class="closeSidebar" @click="closeSidebar()"></div>
        <Settings />
    </div>
    <div class="overlay" v-if="sidebar.menu || sidebar.settings" @click="closeSidebar()"></div>


    <!-- VALIDATE ACCOUNT -->
    <div class="validate-account" v-if="$store.state.statusLogin && $store.state.profile.account_status !== 'Verified' && loadedAccount">
        <div class="container-fluid">
            <div class="cont">
                <p>{{ getMyLanguage("ValidateAccount","message") }}</p>
                <div class="btn-validade-account" @click="checkAccount()">{{ getMyLanguage("ValidateAccount","cta-action") }}</div>
            </div>
        </div>
    </div>
</template>


<script>
    const $ = require("jquery");
    window.$ = $;

    $(document).ready(function () {
        var animaHeader = $("body");
        $(window).scroll(function () {
            if ($(this).scrollTop() > 120) {
                animaHeader.addClass("headerFixed");
            } else {
                animaHeader.removeClass("headerFixed");
            }
        });
    });
   
    import Menu from '@/components/Essentials/Menu.vue';
    import Login from '@/components/Essentials/Login.vue';
    import Sidebar from '@/components/Essentials/Sidebar.vue';
    import Settings from '@/components/Essentials/Settings.vue';

    import bus from '@/eventBus';

    import getMyContentLanguage from "@/services/contentLanguage.js";

    export default {
        props: {
            dataSource: {}
        },

        components: {
            Menu,
            Login,
            Sidebar,
            Settings
        },

        data (){
            return {
                flagSelected: "en",
                loadedAccount: false,

                VUE_APP_DEVELOP: process.env.VUE_APP_DEVELOP,
                VUE_APP_INTERNATIONAL_URL: process.env.VUE_APP_INTERNATIONAL_URL,

                origin: "Header",

                sidebar: {
                    menu: false,
                    settings: false,
                    login: false
                },

                settings: {
                    flagShow: false,
                    flagShipping: "",
                    flagLanguage: "",
                    languageName: "",
                    currencyShort: ""
                },

                dataSourceHeader: {
                    isMerchant: false,
                    headerTemplate: ""
                },

                token: {
                    hasToken: "",
                    id: "",
                    permissions: ""
                }
            }
        },

        async mounted(){
            this.checkToken()

            this.dataSourceHeader.headerTemplate = this.dataSource

            setTimeout(() => {
                this.checkSettings()

                if ( !localStorage.getItem("shippingFlag") ){
                    localStorage.setItem("shippingFlag","58bfc699-7e06-4362-3445-c598e9232900")
                } else {
                    this.settings.flagShipping = localStorage.getItem('shippingFlag')
                }                
            }, 1000);


            setTimeout(() => {
                this.loadedAccount = true
            }, 3000);
        },

        methods: {
            getMyLanguage(group, code){
                return getMyContentLanguage(group, code, this.$store.state.SelectLanguage.code)
            },
            
            languageSelected(){
                this.flagSelected = this.$store.state.SelectLanguage.code
                this.settings.languageName = localStorage.getItem("Language")

                setTimeout(() => {
                    this.settings.flagShow = true
                }, 1500);
            },

            openSidebar(value){
                if ( value == "menu" ){
                    this.sidebar.menu = true
                    document.body.classList.add('body-sidebar-opened')
                }

                if ( value == "settings" ){
                    this.sidebar.settings = true
                    document.body.classList.add('body-settings-opened')
                }
            },
            
            closeSidebar(){
                this.sidebar.menu = false
                this.sidebar.settings = false
                this.sidebar.login = false
                
                document.body.classList.remove('body-sidebar-opened')
                document.body.classList.remove('body-settings-opened')
            },

            checkToken(){
                this.dataSourceHeader.isMerchant = (localStorage.getItem("isMerchant") === "true");
            },

            checkSettings(){
                setTimeout(() => {
                    this.settings.flagShipping = localStorage.getItem("shippingFlag")
                    this.settings.flagLanguage = localStorage.getItem("flagLanguage")
                    this.settings.languageName = localStorage.getItem("Language")
                    this.settings.currencyShort = localStorage.getItem("instrumentTickerShort")
                    this.settings.flagShow = true
                }, 200);
            },

            checkAccount(){
                this.newtk = localStorage.getItem('accessToken')
                window.location.href = `${this.VUE_APP_INTERNATIONAL_URL}${this.flagSelected}/account/token-auth?tk=${this.newtk}&destiny=client-space/purchase`
            }
        },

        watch: {
            '$store.state.SelectLanguage.code': {
                immediate: true,
                handler() {
                    this.languageSelected();
                }
            }
        },

        created() {
            bus.on('open-sidebar', (value) => {
                this.openSidebar(value)
            });

            bus.on('close-sidebar', () => {
                this.closeSidebar()
            });
        }
   }
</script>

<style src="@/assets/scss/_header.scss" lang="scss" scoped />